'use strict';

import Api from './../abstract'
import { APP_TOKEN_NAME } from '@/config'

export let GET_LIST_TERMS = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/terms-use`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };

    return new Api(url, 'get', successCallback, errorCallback, { headers })
};


export let DELETE_TERM = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/terms-use/${params.payload.term_id}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
        'content-type': 'application/json'
    };
    return new Api(url, 'delete', successCallback, errorCallback, { headers })
};


export let GET_DETAIL_TERM = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/terms-use/${params.payload.term_id}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
        'content-type': 'application/json'
    };
    return new Api(url, 'get', successCallback, errorCallback, { headers })
};


export let CREATE_TERM = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/terms-use`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
        'content-type': 'application/json'
    };
    let data = params.payload.data
    return new Api(url, 'post', successCallback, errorCallback, { headers , data })
};


export let UPDATE_TERM = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/terms-use/${params.payload.data.id}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
        'content-type': 'application/json'
    };
    let data = params.payload.data
    return new Api(url, 'put', successCallback, errorCallback, { headers , data })
};



